import Blueline from "../../assets/blueline.svg";
import "./skills.css";
import Html from "../../assets/html.svg";
import Css from "../../assets/css.svg";
import Js from "../../assets/js.svg";
import Figma from "../../assets/figma.svg";
import React from "../../assets/react.svg";
import Node from "../../assets/node.svg";
import Android from "../../assets/android.svg";
import Mongo from "../../assets/mongo.svg";
import { useInView } from "react-intersection-observer";
import { motion, useAnimation } from "framer-motion";
import { useEffect } from "react";

const Skills = () => {
  const { ref, inView } = useInView();
  const animation1 = useAnimation();
  const animation2 = useAnimation();
  const animation3 = useAnimation();
  const animation4 = useAnimation();
  const animation5 = useAnimation();
  const animation6 = useAnimation();
  const animation7 = useAnimation();
  const animation8 = useAnimation();

  useEffect(() => {
    if (inView) {
      animation1.start({
        width: "80%",
        transition: {
          type: "spring",
          duration: 2,
          bounce: 0.3,
        },
      });
      animation2.start({
        width: "60%",
        transition: {
          type: "spring",
          duration: 2,
          bounce: 0.3,
        },
      });
      animation3.start({
        width: "80%",
        transition: {
          type: "spring",
          duration: 2,
          bounce: 0.3,
        },
      });
      animation4.start({
        width: "90%",
        transition: {
          type: "spring",
          duration: 2,
          bounce: 0.3,
        },
      });
      animation5.start({
        width: "90%",
        transition: {
          type: "spring",
          duration: 2,
          bounce: 0.3,
        },
      });
      animation6.start({
        width: "70%",
        transition: {
          type: "spring",
          duration: 2,
          bounce: 0.3,
        },
      });
      animation7.start({
        width: "50%",
        transition: {
          type: "spring",
          duration: 2,
          bounce: 0.3,
        },
      });
      animation8.start({
        width: "60%",
        transition: {
          type: "spring",
          duration: 2,
          bounce: 0.3,
        },
      });
    } else {
      animation1.start({
        width: 0,
      });
      animation2.start({
        width: 0,
      });
      animation3.start({
        width: 0,
      });
      animation4.start({
        width: 0,
      });
      animation5.start({
        width: 0,
      });
      animation6.start({
        width: 0,
      });
      animation7.start({
        width: 0,
      });
      animation8.start({
        width: 0,
      });
    }
  }, [
    animation1,
    animation2,
    animation3,
    animation4,
    animation5,
    animation6,
    animation7,
    animation8,
    inView,
  ]);
  return (
    <div className="n-skills">
      <div className="skill-title">
        <div className="name">
          My <span className="blue-text">Skills</span>
        </div>
        <img className="b-line" src={Blueline} alt="line" />
      </div>
      <div ref={ref} className="skills-elem">
        <div className="s-e-left">
          <div className="skill-item">
            <img className="skills-logo" src={Html} alt="" />
            <div className="skill-perc-container">
              <motion.div
                animate={animation1}
                className="skill-perc-html"
              ></motion.div>
            </div>
          </div>
          <div className="skill-item">
            <img className="skills-logo" src={Css} alt="" />
            <div className="skill-perc-container">
              <motion.div
                animate={animation2}
                className="skill-perc-css"
              ></motion.div>
            </div>
          </div>
          <div className="skill-item">
            <img className="skills-logo" src={Js} alt="" />
            <div className="skill-perc-container">
              <motion.div
                animate={animation3}
                className="skill-perc-js"
              ></motion.div>
            </div>
          </div>
          <div className="skill-item">
            <img className="skills-logo" src={Node} alt="" />
            <div className="skill-perc-container">
              <motion.div
                animate={animation4}
                className="skill-perc-node"
              ></motion.div>
            </div>
          </div>
        </div>
        <div className="s-e-right">
          <div className="skill-item">
            <img className="skills-logo" src={React} alt="" />
            <div className="skill-perc-container">
              <motion.div
                animate={animation5}
                className="skill-perc-react"
              ></motion.div>
            </div>
          </div>
          <div className="skill-item">
            <img className="skills-logo" src={Mongo} alt="" />
            <div className="skill-perc-container">
              <motion.div
                animate={animation6}
                className="skill-perc-mongo"
              ></motion.div>
            </div>
          </div>
          <div className="skill-item">
            <img className="skills-logo" src={Android} alt="" />
            <div className="skill-perc-container">
              <motion.div
                animate={animation7}
                className="skill-perc-android"
              ></motion.div>
            </div>
          </div>
          <div className="skill-item">
            <img className="skills-logo" src={Figma} alt="" />
            <div className="skill-perc-container">
              <motion.div
                animate={animation8}
                className="skill-perc-figma"
              ></motion.div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Skills;
